// Universal blocks API client — talks to RRS /email-universal-block/*.
// Tenant is enforced server-side from the JWT (x-customer-id header added by
// fetchWrapper), so no customer_id is ever sent from the client.
import { fetchWrapper } from '../../../../helpers'

const BASE = `${process.env.REACT_APP_API_URL}/email-universal-block`

export async function listUniversalBlocks({ query = '', kind = '' } = {}) {
  const params = new URLSearchParams({ page: '1', limit: '200' })
  if (query) params.set('query', query)
  if (kind) params.set('kind', kind)
  const res = await fetchWrapper.get(`${BASE}/list?${params.toString()}`)
  return res?.data || []
}

export async function createUniversalBlock({ name, kind = 'block', data, preview_html = '' }) {
  const res = await fetchWrapper.post(`${BASE}/create`, { name, kind, data, preview_html })
  if (res?.success === false) throw new Error(res?.error || 'Failed to save universal block')
  return res?.data?.id
}

export async function updateUniversalBlock({ id, name, data, preview_html }) {
  const body = { id }
  if (name !== undefined) body.name = name
  if (data !== undefined) body.data = data
  if (preview_html !== undefined) body.preview_html = preview_html
  const res = await fetchWrapper.post(`${BASE}/update`, body)
  if (res?.success === false) throw new Error(res?.error || 'Failed to update universal block')
  return res
}

export async function deleteUniversalBlock(id) {
  const res = await fetchWrapper.post(`${BASE}/delete`, { id })
  if (res?.success === false) throw new Error(res?.error || 'Failed to delete universal block')
  return res
}
